import React from 'react'
import {Form, Button } from 'react-bootstrap';

const SearchForm = ({handlechange, text}) => (
    <Form onSubmit={handlechange} className="search-field align-items-center">
	  <Form.Group>
	    <Form.Control autoComplete="off" value={text} type="text" id="search" autoFocus placeholder="Search by topic, service etc" onChange={handlechange}/>
	  </Form.Group>
	  {/* <Button variant="primary" type="submit">
	    <i className="icon-search-icon"></i>
	  </Button> */}
	</Form>
);

export default SearchForm;
